import { lazy } from "react";
import { Navigate } from "react-router-dom";

const LandingPageDashboardV2 = lazy(() => import("pages/Dashboards/Home_V3/Home"));
const EnvHostsSummary = lazy(() => import("pages/Dashboards/Hosts/HostsSummary"));
const EnvHostDetails = lazy(() => import("pages/Dashboards/Hosts/HostDetails"));
const EnvInstancesSummary = lazy(() => import("pages/Dashboards/Instances/InstancesSummary"));
const EnvInstanceDetails = lazy(() => import("pages/Dashboards/Instances/InstanceDetails"));
const EnvDatabasesSummary = lazy(() => import("pages/Dashboards/Databases/DatabaseSummary"));
const EnvDatabaseDetails = lazy(() => import("pages/Dashboards/Databases/DatabaseDetails"));

export const dashboards = [
  // Interceptor for old bff /home redirect on login
  {
    path: "/home",
    element: <Navigate to="/dashboards/dba" replace />,
  },
  {
    path: "dashboards",
    children: [
      {
        path: "dba",
        element: <LandingPageDashboardV2 />,
      },
      {
        path: "host",
        element: <EnvHostsSummary />,
      },
      {
        path: "host_details",
        element: <EnvHostDetails />,
      },
      {
        path: "instance",
        element: <EnvInstancesSummary />,
      },
      {
        path: "instance_details",
        element: <EnvInstanceDetails />,
      },
      {
        path: "database",
        element: <EnvDatabasesSummary />,
      },
      {
        path: "database_details",
        element: <EnvDatabaseDetails />,
      },
    ],
  },
];
